import { createHelpers } from "vuex-map-fields";
import tourApi from "@/services/api/tour";

const getDefaultState = () => {
  return {
    departure: {
      start_date: null,
      end_date: null,
      status: null,
      min_group_size: 0,
      max_group_size: 0,
      public: false,
      price_sync: true,
      prices: {
        gbp: 0,
        eur: 0,
        usd: 0
      },
      created_at: null,
      tour: {
        id: 0,
        title: "",
        type: {
          value: ""
        }
      }
    }
  };
};

const { getDepartureField, updateDepartureField } = createHelpers({
  getterType: "getDepartureField",
  mutationType: "updateDepartureField"
});

const state = getDefaultState();

const getters = {
  getDepartureField
};

const mutations = {
  updateDepartureField,
  setDeparture: (state, departure) => {
    state.departure = departure;
  }
};

const actions = {
  fetchDeparture: ({ commit }, { tourId, departureId }) => {
    return new Promise((resolve, reject) => {
      tourApi
        .getDeparture(tourId, departureId)
        .then(resp => {
          commit("setDeparture", resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateDeparture: ({ commit }, { tourId, departure }) => {
    return new Promise((resolve, reject) => {
      tourApi
        .updateDeparture(tourId, departure)
        .then(resp => {
          commit("setDeparture", resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  resetDeparture: ({ commit }) => {
    let defaultState = getDefaultState();
    commit("setDeparture", defaultState.departure);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
